import React, { useEffect, useState } from "react";
import { Alert, Button, Card, Spinner } from "react-bootstrap";
import Chart from "./ChartJsChart.js";
import { getEventRsvpResponses } from "../api/rsvp.js";
import { CHART_STATUS_COLORS } from "../utils/chartColors.js";

export default function EventRsvpResponsesDistribution({ eventId, definitionId, refreshKey }) {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [reload, setReload] = useState(0);

  useEffect(() => {
    if (!definitionId) {
      setResult(null);
      return undefined;
    }
    const controller = new AbortController();
    setLoading(true);
    setError("");
    setResult(null);
    getEventRsvpResponses({ eventId, definitionId, pageSize: 1, signal: controller.signal })
      .then((response) => { if (!controller.signal.aborted) setResult(response.data); })
      .catch(() => { if (!controller.signal.aborted) setError("Não foi possível carregar a distribuição geral das respostas."); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [definitionId, eventId, refreshKey, reload]);

  const summary = result?.summary;
  const isAttendance = definitionId === result?.registry?.attendance_definition_id;
  const segments = isAttendance ? [
    { label: "Participação confirmada", value: Number(summary?.yes || 0), color: CHART_STATUS_COLORS.success },
    { label: "Participação não confirmada", value: Number(summary?.no || 0), color: CHART_STATUS_COLORS.danger },
  ] : [{ label: "Respondidos", value: Number(summary?.yes || 0) + Number(summary?.no || 0), color: CHART_STATUS_COLORS.success }];
  segments.push(
    { label: "Sem resposta", value: Number(summary?.unanswered || 0), color: CHART_STATUS_COLORS.secondary },
    { label: "Revisão necessária", value: Number(summary?.other || 0), color: CHART_STATUS_COLORS.warning },
  );

  return <Card className="mb-0">
    <Card.Body>
      <h6>Distribuição geral das respostas</h6>
      <p className="small text-muted">Todos os participantes do RSVP selecionado, independentemente dos filtros da tabela.</p>
      {!definitionId ? <p className="text-muted mb-0">Selecione um RSVP para consultar a distribuição.</p>
        : loading ? <div className="py-4" role="status"><Spinner animation="border" size="sm" className="me-2" />Carregando distribuição…</div>
          : error ? <Alert variant="warning" className="mb-0"><span>{error}</span><Button size="sm" variant="outline-secondary" className="ms-2" onClick={() => setReload((value) => value + 1)}>Tentar novamente</Button></Alert>
            : !summary ? <p className="text-muted mb-0">Distribuição indisponível.</p>
              : !Number(summary.total) ? <p className="text-muted mb-0">Nenhum participante neste evento.</p>
                : <Chart
                    type="donut"
                    height={300}
                    series={segments.map((segment) => segment.value)}
                    options={{
                      labels: segments.map((segment) => segment.label),
                      colors: segments.map((segment) => segment.color),
                      legend: { position: "bottom" },
                      tooltip: { y: { formatter: (value) => Number(value).toLocaleString("pt-BR") } },
                    }}
                  />}
    </Card.Body>
  </Card>;
}
